// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellCard-cls1_KfV","cls2":"TasteOfMentionsUpsellCard-cls2_dOR TasteOfMentionsUpsellCard-cls1_KfV"};